import React from 'react';
import { makeEllipsisString } from 'tools/StringTool';
import { SelectMallContainer } from './style';

const SelectMallStep = ({ mallList, setSelectedMallData, setStep }) => {
  const mallListGroupMap = [
    { name: '오픈마켓', list: mallList?.openMarketList },
    { name: '종합몰', list: mallList?.generalMallList },
    { name: '홈쇼핑', list: mallList?.homeShoppingMallList },
    { name: '전문몰', list: mallList?.specialtyMallList },
    { name: 'PG사', list: mallList?.paymentGateWayMallList },
    {
      name: '폐쇄몰',
      list: mallList?.corporateClosedShoppingMallList,
    },
    { name: '오픈 예정', list: mallList?.notOpenMallList },
  ];

  // 판매몰 선택
  const onClickMallBtn = mallData => {
    setSelectedMallData(mallData);
    setStep('accountStep');
  };

  return (
    <SelectMallContainer>
      <p className="notice">데이터 연동을 위한 판매몰을 선택해 주세요</p>
      {mallListGroupMap
        ?.filter(group => group.list?.length > 0)
        .map((group, index) => {
          return (
            <section key={group.name + index}>
              <p>{group.name}</p>
              <ul key={group.name}>
                {group?.list?.map((item, index) => (
                  <li key={index} onClick={() => onClickMallBtn(item)}>
                    <div>
                      <img src={item.fileUrl} alt={`${item.mallName}`} />
                    </div>
                    <p>{makeEllipsisString(item.mallName, 8)}</p>
                  </li>
                ))}
              </ul>
            </section>
          );
        })}
    </SelectMallContainer>
  );
};

export default SelectMallStep;
